/* eslint-disable jsx-a11y/no-onchange */
import Image from '@/components/common/SpiritoryImage';
import { useCallback } from 'react';
import clsx from 'clsx';
import { ImagesSkusSortSvg } from '@/assets/images_skus.assets';
import { SkusMobileSearchSortByProps } from '@/types/props/components/skus';
import useSortOptions from '@/components/skus/hooks/useSortOptions';

export default function SkusMobileSearchSortBy({
  allSortsCustomTranslated,
}: SkusMobileSearchSortByProps) {
  const { initialIndex, currentRefinement, options, refine } = useSortOptions({
    items: allSortsCustomTranslated,
  });

  const getCurrentRefinementName = useCallback(() => {
    let index = options.find((option) => option.value === currentRefinement);
    if (!index) {
      index = options.find((option) => option.value === initialIndex);
    }
    return index?.label;
  }, [currentRefinement, initialIndex, options]);

  return (
    <div className="tw-relative tw-inline-block tw-text-left tw-w-10 tw-h-10 tw-overflow-hidden">
      <Image
        src={ImagesSkusSortSvg}
        width={24}
        height={24}
        alt="sort"
        className="tw-absolute tw-inset-0 tw-m-auto tw-pointer-events-none"
      />
      <select
        onChange={(e) => refine(e.target.value)}
        className={clsx(
          'tw-absolute tw-inset-0 tw-opacity-0 tw-w-full tw-h-full',
          'tw-cursor-pointer tw-appearance-none'
        )}
        value={currentRefinement}
        aria-label={`Sort by: ${getCurrentRefinementName()}`}
      >
        {options.map((sort, index) => (
          <option key={index} value={sort.value}>
            {sort.label}
          </option>
        ))}
      </select>
    </div>
  );
}
